<div class="fixed transform z-1" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-3 pb-3">
  <div class="flex justify-content-between align-items-center title-bg">
    <div class="back-button static cursor-pointer" (click)="routeBack();" pTooltip="Back to Facility Benchmarks"
      tooltipPosition="right">
      <i class="pi pi-arrow-left"></i>
    </div>
    <div class="facility-field col-12 md:col-6 lg:col-8" style="transform: translate(0%, 38%);">
      <span class="p-input-icon-right w-full">
        <p-dropdown class="w-full" placeholder="Select Facility" pTooltip="Select Facility" tooltipPosition="top"
          [options]="allQualityGoal" [(ngModel)]="FacilityID" (onChange)="updateFaciiltyData();"
          optionValue="FacilityID" [filter]="true" optionLabel="FacilityName">
        </p-dropdown>
      </span>
    </div>
    <span class="full-screen">
      <p-button label="Export to Excel" icon="pi pi-upload" [loading]="exportExcelLoader" (click)="exportExcel()"
        class="p-button-primary"></p-button>
    </span>
    <span class="mac-screen">
      <p-button icon="pi pi-file-excel" [loading]="exportExcelLoader" (click)="exportExcel()"
        class="p-button-primary"></p-button>
    </span>
  </div>

  <p-table #quarter [value]="editQualityGoal" [rows]="10" styleClass="p-datatable-striped p-datatable-gridlines"
    responsiveLayout="scroll" [rowHover]="true" dataKey="id" [resizableColumns]="true" columnResizeMode="expand"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
    [globalFilterFields]="['FieldName','Quarter1','Quarter2','Quarter3','Quarter4']">
    <ng-template pTemplate="caption">

      <div class="title-casefacility mt-0 title-bg title-case">
        <div class="conten clean-small">
          <div class="btn"><a>Facility Benchmarks</a></div>
        </div>
          <span class="editbench-calender">
            <p-calendar [(ngModel)]="date1" view="year" dateFormat="yy" [showIcon]="true"
            (ngModelChange)="getQuarterDataInEditFacility(date1.getFullYear())" inputId="yearpicker"></p-calendar>
          </span>
          <span class="p-input-icon-left search-editbench">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="applyFilterGlobalForQuarter($event, 'contains')"
              placeholder="Search Facility Benchmarks" />
          </span>

      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="FieldName" style="width: 45%;">Fields <p-sortIcon field="FieldName"></p-sortIcon>
        </th>
        <th>Quarter 1
          <p-button *ngIf="isAccessReadWrite && !roleForFacility"
             icon="pi pi-pencil"
            pTooltip="Edit Quarter 1" tooltipPosition="top" placeholder="Top" class="p-button-primary float-right -m-2"
            (click)="EditQulityGoalsByQuarter('1')"></p-button>
        </th>
        <th>Quarter 2
          <p-button *ngIf="isAccessReadWrite && !roleForFacility"
            icon="pi pi-pencil"
            pTooltip="Edit Quarter 2" tooltipPosition="top" placeholder="Top" class="p-button-primary float-right -m-2"
            (click)="EditQulityGoalsByQuarter('2')"></p-button>
        </th>
        <th>Quarter 3
          <p-button *ngIf="isAccessReadWrite && !roleForFacility"
            icon="pi pi-pencil"
            pTooltip="Edit Quarter 3" tooltipPosition="top" placeholder="Top" class="p-button-primary float-right -m-2"
            (click)="EditQulityGoalsByQuarter('3')"></p-button>
        </th>
        <th>Quarter 4
          <p-button *ngIf="isAccessReadWrite && !roleForFacility"
            icon="pi pi-pencil"
            pTooltip="Edit Quarter 4 " tooltipPosition="top" placeholder="Top"
            class=" p-button-primary float-right -m-2" (click)="EditQulityGoalsByQuarter('4')">
          </p-button>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-editQualityGoal>
      <tr *ngIf="editQualityGoal.FieldName != 'gd_key' && editQualityGoal.FieldName != 'gd_qag_key' ">
        <td>
          {{editQualityGoal.FieldName}}
        </td>
        <td class="text-right">
          {{editQualityGoal.Quarter1}}
        </td>
        <td class="text-right">
          {{editQualityGoal.Quarter2}}
        </td>
        <td class="text-right">
          {{editQualityGoal.Quarter3}}
        </td>
        <td class="text-right">
          {{editQualityGoal.Quarter4}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <h5 *ngIf="totalRecords==0" class="text-center create-roles">
          <b> No records found</b>
        </h5>
      </tr>
    </ng-template>
  </p-table>
  <div class="md:col-12">
    <span class="tableRefreshTime ml-0">
      Grid Last Refreshed at {{PiTeamService._currentDate}} - {{PiTeamService._currentTime}}
    </span>
  </div>
</div>

<!-- //////////////////////// date and quarter dialog for edit quarter ////////////////////////////// -->

<p-dialog [(visible)]="productDialogForEditQuarter" [breakpoints]="{'960px': '75vw'}" [draggable]="false"
  [style]="{width: '63vw'}" [header]="facilityGoalsStr" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <p-toast key="productDialogForEditQuarter" position="top-right"></p-toast>
    <div class="faclity-popup">
      <div class="grid m-3">
        <div class="col-12 md:col-6 lg:col-4">
          <label for="yearpicker">Pick Year</label>
          <p-calendar [(ngModel)]="addQualityGoalDate" view="year" dateFormat="yy" [showIcon]="true"
            (ngModelChange)="selectedQuartersAndDateAdd()" inputId="yearpicker" [disabled]="disableYear == true">
          </p-calendar>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
          <label for="yearpicker">Quarter</label>
          <p-dropdown [options]="selectedQuarterOptions" [(ngModel)]="selectedQuarter"
            (ngModelChange)="selectedQuartersAndDateAdd()" optionLabel="name" optionValue="code"
            [disabled]="disableQuarter == true"></p-dropdown>
        </div>
      </div>
      <div *ngIf="addFacilityGoalsResponseObj">
        <div class="grid m-3">
          <div class="col-12 md:col-6 lg:col-4">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Door to TS Notification Avg Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" pInputText
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_door_to_TS_notification_ave_minutes" maxlength="4" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Door to TS Notification Median Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_door_to_TS_notification_median_minutes" maxlength="4"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">% 10 Min or Less Activation (EMS)</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_percent10_min_or_less_activation_EMS" maxlength="4"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">% 10 Min or Less Activation (PV)</label>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_percent10_min_or_less_activation_PV" maxlength="4"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Activation to Assessment Mean Mins</label>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_activation_to_assessment_time_avg_min" maxlength="4"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Activation to Assessment Median Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_activation_to_assessment_time_median_min" maxlength="4"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">TS Notification to Initial Response Mean Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_TS_notification_to_response_average_minute" maxlength="4"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">TS Notification to Initial Response Median Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_TS_notification_to_response_median_minute"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Door to Needle Mean (Min:Sec)</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_door_to_needle_average"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Door to Needle Median (Min:Sec)</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_door_to_needle_median"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Activation to Needle Mean (Min:Sec)</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_Activation_to_Needle_mean_min"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Activation to Needle Median (Min:Sec)</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_Activation_to_Needle_Median_min"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Assessment to Thrombolytic Decision-making Mean Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_verbal_order_to_administration_average_minutes"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Assessment to Thrombolytic decision making Median Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_assessment_to_thrombolytic_decision_making_median_min"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Thrombolytic Medical Decision to Admin Mean Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_thrombolytic_medicaldecision_to_administration_average_minutes"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">Thrombolytic Decision Making to Admin Median Mins</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_thrombolytic_decision_making_to_thrombolytic_administration_med_min"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">DTN less or equal 30 Minutes %</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_DTN_grter_or_equal_30minutes_percent"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>

          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">DTN less or equal 45 Minutes %</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_DTN_grter_or_equal_45minutes_percent"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-4 bench-box">
            <div class="grid">
              <div class="col-12 md:col-10 lg:col-10">
                <label class="label-bg" for="text">DTN less or equal 60 Minutes %</label>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <input type="text" class="labelbg-input" pInputText maxlength="4"
                  [(ngModel)]="addFacilityGoalsResponseObj.qag_DTN_grter_or_equal_60minutes_percent"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
              </div>
            </div>
          </div>

        </div> <!-- Grid close -->

      </div>
    </div>

  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="hideProductDialogForEditQuarter()" class=" btn-UnCancelCase">
      <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
    <p-button [disabled]="onClickDisable"
      [ngStyle]="onClickDisable?{'pointer-events': 'none'} : {'pointer-events': 'all'}" pRipple label="Save"
      class="p-button-text p-button-primary p-0 btn-padding-custom" icon="pi pi-check"
      (click)="saveSelectedQuartersAndDate()" [loading]="quarterfacilityLoader"></p-button>
  </ng-template>
</p-dialog>

<p-toast key="FacilityData" position="top-right"></p-toast>
<!-- ///////////////////End date and quarter dialog for edit quarter//////////////////////////// -->

<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="onReject()">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="onConfirm()" type="button">
          </p-button>
        </div>
        <div class="col-6">
          <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="onReject()" type="button">
          </p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
